import { type Address, erc20Abi } from 'viem';
import { AccountantAbi } from '../contracts/accountant-abi';
import { BoringVaultAbi } from '../contracts/boring-vault-abi';
import { getClient } from '../lib/client';
import type { ChainId } from './vault-config';

type AccountantBaseProps = {
  accountantAddress: Address;
  chainId: ChainId;
};

type RateInQuoteWithAssetDecimalsProps = AccountantBaseProps & {
  assetAddress: Address;
};

// TODO: Duplicated in multicall compare and remove
const getRateInQuoteWithAssetDecimals = async ({
  assetAddress,
  accountantAddress,
  chainId,
}: RateInQuoteWithAssetDecimalsProps) => {
  const client = await getClient(chainId);

  const results = await client.multicall({
    contracts: [
      {
        abi: erc20Abi,
        address: assetAddress,
        functionName: 'decimals',
      },
      {
        abi: AccountantAbi,
        address: accountantAddress,
        functionName: 'getRateInQuote',
        args: [assetAddress],
      },
    ],
  });
  return results;
};

type RateInQuoteAndSharesAndWantAssetDecimalsParams = {
  sharesAssetAddress: Address;
  wantAssetAddress: Address;
  accountantAddress: Address;
  chainId: ChainId;
};

// TODO: Move to multicall
const getRateInQuoteAndSharesAndWantAssetDecimals = async ({
  sharesAssetAddress,
  wantAssetAddress,
  accountantAddress,
  chainId,
}: RateInQuoteAndSharesAndWantAssetDecimalsParams) => {
  const client = await getClient(chainId);

  const results = await client.multicall({
    contracts: [
      {
        abi: erc20Abi,
        address: wantAssetAddress,
        functionName: 'decimals',
      },
      {
        abi: BoringVaultAbi,
        address: sharesAssetAddress,
        functionName: 'decimals',
      },
      {
        abi: AccountantAbi,
        address: accountantAddress,
        functionName: 'getRateInQuote',
        args: [wantAssetAddress],
      },
    ],
  });
  return results;
};

export {
  getRateInQuoteAndSharesAndWantAssetDecimals,
  getRateInQuoteWithAssetDecimals,
};
